<template>
    <div name="concierge" class="concierge">
        <!-- 홈 배너 진입: 쇼케이스 공통 -->
        <img v-if="type !== 1" class="back" src="../../assets/showcase/xi/concierge_back.png" @click="goHome"/>
        <!-- 1:1 컨시어지 / 고객센터 / 하단 컨시어지 버튼 진입 -->
        <img v-else-if="showcase === 'bodyfriend'" class="back" src="../../assets/showcase/xi/concierge_back_bodyfriend.png" @click="goHome"/>
        <img v-else class="back" src="../../assets/showcase/xi/concierge_resident.png" @click="goHome"/>
    </div>
</template>

<script>
export default {
    name: 'concierge',
    props: {
        type: {
            type: Number,
            default: 0
        }
    },
    computed: {
        showcase: function() {
            return this.$route.params.showcase
        }
    },
    methods: {
        goHome: function()
        {
            this.$emit('goHome')
        }
    }
}
</script>

<style scoped>
    .concierge {
        width: 100%;
    }
    .back{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Concierge.vue